__turbopack_context__.v({
  "darktext": "QhG98q_darktext",
  "form": "QhG98q_form",
  "formControls": "QhG98q_formControls",
  "formMessage": "QhG98q_formMessage",
  "richtext": "QhG98q_richtext",
  "rowSwapped": "QhG98q_rowSwapped",
  "splitview": "QhG98q_splitview",
  "splitviewimage": "QhG98q_splitviewimage",
  "splitviewtext": "QhG98q_splitviewtext",
  "swapped": "QhG98q_swapped",
});
